<template>
  <div class="p-8">
    <p class="text-primary">
      <span v-if="alertData.action === 'delete'">
        You and all other team members will lose access to {{ alertData.metadata.name }} permanently.
      </span>
      <span v-else>
        You will lose access to {{ alertData.metadata.name }}. You can always rejoin the team by using the invite link sent to you.
      </span>
    </p>
    <div class="mt-4" v-if="alertData.action === 'delete'">
      <p class="text-primary mb-4">Enter the team name <span class="underline">{{ alertData.metadata.name }}</span> to confirm deletion:</p>
      <Input type="text" v-model="inputTeamName" :placeholder="alertData.metadata.name" class="w-full" />
      <p class="text-sm text-muted-foreground mt-2">
        Looking to transfer ownership instead? 
        <NuxtLink :to="`/team/${alertData.id}/settings`" class="text-primary hover:underline">
          Go to team settings
        </NuxtLink>
      </p>
    </div>
    <div v-if="deletePending" class="flex items-center justify-center mt-4">
      <Loader2 class="w-6 h-6 animate-spin" />
      <span class="ml-2">Processing...</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useBottomDrawer } from '@/composables/useBottomDrawer'
import { isEqual } from 'lodash-es'

interface TeamAlertData {
  id: string
  metadata: {
    name: string
    archived?: boolean
    muted?: boolean
  }
  action: 'delete' | 'leave'
}

const props = defineProps<{
  alertData: TeamAlertData
  inputTeamName: string
  deletePending: boolean
}>()

const emit = defineEmits<{
  'update:inputTeamName': [value: string]
}>()

const inputTeamName = computed({
  get: () => props.inputTeamName,
  set: (value) => emit('update:inputTeamName', value)
})

const { setConfirmEnabled } = useBottomDrawer()

const areStringsEqual = (str1: string, str2: string) => {
  return str1 === str2
}

const isValid = computed(() => {
  if (props.alertData.action === 'delete') {
    return areStringsEqual(inputTeamName.value, props.alertData.metadata.name)
  }
  return true
})

// Watch for changes in validation state
watch(isValid, (newVal) => {
  setConfirmEnabled(newVal)
}, { immediate: true })
</script> 